export function updateObjectField(obj, field, value) {
    return {...obj, [field]: value};
}

export function mapObjectToArray(obj, func) {
    let out = [];

    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            out.push(func(key, obj[key]));
        }
    }

    return out;
}